import { Shell } from "@/components/layout/Shell";
import { useSeo } from "@/hooks/use-seo";

export default function Disclaimer() {
  useSeo({
    title: "Disclaimer | Mychromamind",
    description:
      "Mychromamind is for entertainment and self-reflection only. It is not psychological, medical, legal, or financial advice.",
    path: "/disclaimer",
  });

  return (
    <Shell>
      <div className="max-w-3xl mx-auto px-6 py-12 md:py-24 w-full prose prose-neutral dark:prose-invert">
        <h1 className="font-serif">Disclaimer</h1>
        <p className="text-sm text-muted-foreground">Last updated: July 8, 2026</p>

        <p>
          Mychromamind is built purely for entertainment and light self-reflection. It's a
          playful way to explore color psychology — how colors are broadly associated with
          moods, traits, and feelings — not a scientific instrument or diagnostic tool.
        </p>

        <h2>Not professional advice</h2>
        <p>
          Nothing on this site — quiz results, personality reads, decision guidance, or color
          meanings — is psychological, medical, legal, financial, or professional advice of any
          kind. These results are generated from your color choices using simplified, general
          associations and should not be relied on to make real-world decisions, diagnose or
          treat any condition, or replace guidance from a qualified professional.
        </p>

        <h2>No guarantee of accuracy</h2>
        <p>
          Color psychology associations vary by individual, culture, and context, and the
          content here is intentionally general and illustrative. We make no claims that any
          result is accurate, complete, or applicable to your specific situation.
        </p>

        <h2>If you need real support</h2>
        <p>
          If you're facing a decision or situation that affects your health, finances, safety, or
          wellbeing, please consult a qualified professional or a trusted person in your life
          rather than relying on this site.
        </p>

        <p>
          By using Mychromamind, you acknowledge and accept that it is offered "as is," for fun
          and reflection, with no warranty of any kind.
        </p>
      </div>
    </Shell>
  );
}
